import React from 'react'
import { Edit } from 'react-admin'

import ChannelForm from './form'

const BroadcasterTitle = ({ record }) => {
  return <span>{`Channel: ${record.nombre}`}</span>
}

export const ChannelEdit = (props) => (
  <Edit undoable={false} title={<BroadcasterTitle />} {...props}>
    <ChannelForm {...props} />
  </Edit>
)

export default ChannelEdit
